<template>
  <nav>
    <div class="nav-inner">
      <img :src="baseUrl + logo" class="logo">
      <ul class="menu">
        <router-link to="home" class="menu-item">首页</router-link>
        <router-link to="hall" class="menu-item">办事大厅</router-link>
        <router-link to="apps" class="menu-item" v-if="isLogin">应用中心</router-link>
        <router-link to="task" class="menu-item" v-if="isLogin">任务中心</router-link>
      </ul>
      <div class="profile" v-if="isLogin">
        <div class="username">{{ userInfo.name }}</div>
        <el-dropdown trigger="click">
          <img class="avatar" :src="userInfo.headUrl ? baseUrl + userInfo.headUrl : require('../../assets/avatar.jpg')"
            width="42">
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="$router.push('personal')">个人中心</el-dropdown-item>
            <el-dropdown-item divided @click.native="logout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="login" @click="$router.push('/login')" v-else>登录</div>
    </div>
  </nav>
</template>

<script>
import { getUserInfo } from '../../layout/api'
export default {
  name: 'Navigation',
  data() {
    return {
      baseUrl: localStorage.getItem('baseUrl'),
      logo: localStorage.getItem('logo'),
      userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {},
      isLogin: localStorage.getItem('sys_token')
    }
  },
  async created() {
    if (this.isLogin) {
      const { data } = await getUserInfo()
      this.userInfo = data
      localStorage.setItem('userInfo', JSON.stringify(data))
    }
  },
  methods: {
    logout() {
      localStorage.removeItem('sys_token')
      localStorage.removeItem('userInfo')
      this.$router.push('/home')
      location.reload()
    }
  }
}
</script>

<style lang="scss" scoped>
nav {
  width: 100%;
  position: sticky;
  top: 0;
  z-index: 1;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background: $mainColor;
    z-index: -1;
  }

  .nav-inner {
    width: var(--inner-width);
    height: var(--nav-height);
    margin: auto;
    display: flex;
    align-items: center;

    .logo {
      height: 50px;
    }

    .menu {
      height: 100%;
      display: flex;
      margin-left: 50px;
      gap: 30px;

      &-item {
        width: 150px;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 20px;
        color: #ffffff98;
        border-bottom: 4px solid transparent;
        font-weight: normal;
        transition: 300ms;

        &:hover {
          color: #fff;
        }

        &.router-link-active {
          -webkit-text-stroke: .5px #fff;
          border-bottom: 4px solid #fff;
          color: #fff;
        }
      }
    }

    .profile {
      margin-left: auto;
      display: flex;
      align-items: center;
      gap: 20px;

      .username {
        font-size: 18px;
        color: #f9fbfc;
      }

      .avatar {
        border-radius: 50%;
      }
    }

    .login {
      margin-left: auto;
      font-size: 18px;
      font-weight: bold;
      padding: 10px 30px;
      color: #fff;
      border-radius: 4px;
      background: rgba(255, 255, 255, 0.3);
      cursor: pointer;
    }
  }
}
</style>